import { dateToDbMonthDateString } from './convert';

export function getFirstDateOfMonth(year: number, month: number) {
    return new Date(year, month, 1);
}

export function getLastDateOfMonth(year: number, month: number) {
    return new Date(year, month + 1, 0);
}

export function getYear(date: Date) {
    return date.getFullYear();
}

export function getMonth(date: Date) {
    return date.getMonth();
}

export function getDayOfMonth(date: Date) {
    return date.getDate();
}

export function monthDiff(d1: Date, d2: Date) {
    let months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth();
    months += d2.getMonth();
    return months <= 0 ? 0 : months;
}

export function formatMonthStrings(beginYear: number, beginMonth: number, monthCount: number) {
    const months: Array<string> = [];
    for (let m = beginMonth; m <= beginMonth + monthCount; m++) {
        const date = new Date(beginYear, m, 1);
        months.push(dateToDbMonthDateString(date));
    }
    return months;
}
